import { Component, computed, effect, HostListener, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getAWSAssetURL } from 'src/app/constants/assets';
import { StyleImage } from 'src/app/interfaces/style-image';
import { StyleImageGalleryData } from 'src/app/interfaces/style-image-gallery-data';

@Component({
  selector: 'app-style-image-gallery',
  templateUrl: './style-image-gallery.component.html',
  styleUrl: './style-image-gallery.component.scss'
})
export class StyleImageGalleryComponent {
  data = inject<StyleImageGalleryData>(MAT_DIALOG_DATA);
  images = signal(this.data.images.map(image => ({ url: getAWSAssetURL(image.fileName.replace('{{size}}', 'large')), styleImage: image })));
  activeImage = signal(this.data.selectedImage);
  activeImageIndex = computed(() => this.images().findIndex(image => image.styleImage.fileName === this.activeImage().fileName));

  @HostListener('document:keydown', ['$event'])
  onDocumentKeyPress(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft' && this.activeImageIndex() > 0) {
      this.activeImage.set(this.images()[this.activeImageIndex() - 1].styleImage);
    } else if (event.key === 'ArrowRight' && this.activeImageIndex() < this.images().length - 1) {
      this.activeImage.set(this.images()[this.activeImageIndex() + 1].styleImage);
    }
    return true;
  }
}
